import React from 'react';
import cn from 'classnames';
import PropTypes, { object } from 'prop-types';

import {
  Heading,
  Text,
  TablePerson,
  EmptyState,
  TextWithTooltip,
  DateTime
} from 'components/common/Elements/Elements';

import classes from './NotificationsTable.module.scss';

const NotificationsTable = ({ notifications, handleRead }) => {
  if (!notifications) return <EmptyState />;

  return (
    <ul>
      {notifications &&
        notifications.length !== 0 &&
        notifications.map(notification => (
          <li
            key={notification._id}
            className={cn(
              classes.massage,
              !notification.isRead && classes.massage_noRead
            )}
            onClick={
              !notification.isRead
                ? () => handleRead(notification._id)
                : handleRead('')
            }
          >
            <div className={classes.info}>
              <TablePerson person={notification.recivedFrom} size="l" />
              <div className={classes.info_person}>
                <Heading>
                  <TextWithTooltip text={notification.recivedFrom} />
                </Heading>
                <Text>
                  <TextWithTooltip text={notification.userEmail} />
                </Text>
              </div>
            </div>
            <div className={classes.info}>
              <div
                className={cn(
                  classes.readStatus,
                  notification.isRead
                    ? classes.readStatus_read
                    : classes.readStatus_noRead
                )}
              />
              <div>
                <Heading>{notification.title}</Heading>
                <Text>{notification.message}</Text>
              </div>
            </div>
            <div className={classes.info}>
              <DateTime date={notification._created_at} time />
            </div>
          </li>
        ))}
    </ul>
  );
};

NotificationsTable.propTypes = {
  notifications: PropTypes.arrayOf(object),
  handleRead: PropTypes.func.isRequired
};

export default NotificationsTable;
